import { render, staticRenderFns } from "./NewPerformances.vue?vue&type=template&id=197310c2&scoped=true"
import script from "./NewPerformances.vue?vue&type=script&lang=js"
export * from "./NewPerformances.vue?vue&type=script&lang=js"
import style0 from "./NewPerformances.vue?vue&type=style&index=0&id=197310c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197310c2",
  null
  
)

export default component.exports